import { beforeEach, describe, expect, it, vi } from 'vitest';

import middleware from './whitelabel.global';

const { findClaimById, setReady, whitelabelFind, whitelabelGet } = vi.hoisted(() => {
  const fns = {
    findClaimById: vi.fn(),
    setReady: vi.fn(),
    whitelabelFind: vi.fn(),
    whitelabelGet: vi.fn(),
  };

  vi.stubGlobal('defineNuxtRouteMiddleware', handler => handler);

  return fns;
});

vi.mock('~/store', () => ({
  useApplicationStore: () => ({ setReady }),
  useWhiteLabelStore: () => ({ find: whitelabelFind, get: whitelabelGet }),
}));
vi.mock('~/store/claim', () => ({ useClaimStore: () => ({ findClaimById }) }));
vi.mock('~/store/orders', () => ({ useOrdersStore: () => ({ currentOrder: null }) }));

const route = (path = '/view/claim-1', query = {}) => ({ params: { token: 'claim-1' }, path, query });

describe('whitelabel global middleware', () => {
  beforeEach(() => {
    [findClaimById, setReady, whitelabelFind, whitelabelGet].forEach(m => m.mockReset());
    whitelabelGet.mockReturnValue(null);
    whitelabelFind.mockResolvedValue(undefined);
  });

  it('uses the claim store id when the claim is readable', async () => {
    findClaimById.mockResolvedValue({ storeId: 'store-1' });

    await middleware(route());

    expect(whitelabelFind).toHaveBeenCalledWith(null, 'store-1');
    expect(setReady).toHaveBeenCalled();
  });

  /**
   * This middleware is global, so it runs before the page's guest-session middleware has redeemed an
   * email link — the claim read is refused at that point. It used to reject and take the navigation
   * with it, which showed up as a 403 on every emailed deep link once the guards were enforcing.
   */
  it('still resolves branding when the claim read is refused', async () => {
    findClaimById.mockRejectedValue(Object.assign(new Error('Forbidden'), { response: { status: 403 } }));

    await middleware(route());

    expect(whitelabelFind).toHaveBeenCalledWith(null, null);
    expect(setReady).toHaveBeenCalled();
  });

  it('does not read the claim at all when the store is already known', async () => {
    await middleware(route('/view/claim-1', { store: 'store-from-query' }));

    expect(findClaimById).not.toHaveBeenCalled();
    expect(whitelabelFind).toHaveBeenCalledWith(null, 'store-from-query');
  });

  it('skips everything when branding is already loaded', async () => {
    whitelabelGet.mockReturnValue('#fff');

    await middleware(route());

    expect(findClaimById).not.toHaveBeenCalled();
    expect(whitelabelFind).not.toHaveBeenCalled();
    expect(setReady).toHaveBeenCalled();
  });
});
